import { useEffect, useState } from "react"
import { FehlerauswertungErrResp } from "../../Fehler/FehlerauswertungErrResp";

export default function NeuesErfassungsjahr({ vvdInstance, ldInstance, bhfdInstance, absdInstance }) {
    const [vvdYears, setVvdYears] = useState([0]);
    const [ldYears, setLdYears] = useState([0]);
    const [bhfYears, setBhfYears] = useState([0]);
    const [absYears, setAbsYears] = useState([0]);
    const [bhfPossibleYears, setBhfPossibleYears] = useState([0]);
    const [absPossibleYears, setAbsPossibleYears] = useState([0]);

    useEffect(() => {
        vvdInstance.getYearsVerkehrsvertragsdatenGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setVvdYears(data);
            }
        })

        ldInstance.getYearsLiniendaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setLdYears(data);
            }
        })

        bhfdInstance.getPossibleYearsBahnhofsdaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setBhfPossibleYears(data);
            }
        })

        bhfdInstance.getExistentYearsBahnhofsdaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setBhfYears(data);
            }
        })
        absdInstance.getPossibleYearsAbschnittsdaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setAbsPossibleYears(data);
            }
        })

        absdInstance.getExistentYearsAbschnittsdaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setAbsYears(data);
            }
        })


    }, [vvdInstance, ldInstance, bhfdInstance, absdInstance]);

    const reload = () => {
        vvdInstance.getYearsVerkehrsvertragsdatenGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setVvdYears(data);
            }
        })

        ldInstance.getYearsLiniendaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setLdYears(data);
            }
        })
        bhfdInstance.getExistentYearsBahnhofsdaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setBhfYears(data);
            }
        })
        absdInstance.getExistentYearsAbschnittsdaten((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setAbsYears(data);
            }
        })
    }

    const addAbsd = event => {
        event.preventDefault();
        console.log("absd für ", event.target.value)
        absdInstance.createAbsdForSpecificYear(event.target.value, (error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                alert("Hat geklappt!");
                reload();
            }
        });
    }

    const addBd = event => {
        event.preventDefault();
        console.log("bd für ", event.target.value)
        bhfdInstance.createBdForSpecificYear(event.target.value, (error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);

            } else {
                alert("Hat geklappt!");
                reload();
            }
        });
    }

    const addLd = event => {
        event.preventDefault();
        console.log("ld für ", event.target.value)
        ldInstance.createLdForSpecificYear(event.target.value, (error, data, response) => {
            if (error) {
                console.log(error);
                 FehlerauswertungErrResp(error, response);

            } else {
                alert("Hat geklappt!");
                reload();
            }
        });
    }

    const addVvd = event => {
        event.preventDefault();
        console.log("vvd für ", event.target.value)
        vvdInstance.createVvdForSpecificYear(event.target.value, (error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);

            } else {
                alert("Hat geklappt!");
                reload();
            }
        });
    }

    return (
        <div>
            <h1>Anlegen eines neuen Jahres</h1>
            <p>...Die Idee:
                <br></br>
                Einmal die Tabellen "Verkehrsvertrag zu Linie zu Produkt" und die Gültigkeiten in "Verkehrsvertrag" ordentlich pflegen und
                bei Bedarf für das neue Jahr entsprechend bearbeiten.
                <br></br>
                Anschließend können hier über einen Knopfdruck alle Datenerfassungstabellen für das neue Jahr erstellt werden.
            </p>
            <p>
                Macht es Sinn gleich alle Tabellen anzulegen? --- ja
                <br></br>
                Sollte eine nachträgliche Bearbeitung möglich sein? --- ja: löschen einzelner Zeilen und hinzufügen einzlener neuer Zeilen.
                <br></br>
                Außerdem beim Bearbeiten der VLP-Tabelle immer gegenprüfen, ob es bestehende Datenerfassungsdaten beeinflusst und entsprechend markieren.
            </p>

            <div>
                <h3>Bisher eingepflegte Jahre:</h3>
                <ul>
                    <li>
                        Abschnittsdaten:
                        <p>bereits vorhanden: {JSON.stringify(absYears)}</p>
                        <p>Tagesgruppen liegen vor: {JSON.stringify(absPossibleYears)}</p>
                        <button onClick={addAbsd} value={absYears.at(-1) + 1}>{absYears.at(-1) + 1} neu anlegen</button>
                    </li>
                    <li>Bahnhofsdaten:
                        <p>bereits vorhanden: {JSON.stringify(bhfYears)}</p>
                        <p>Tagesgruppen liegen vor: {JSON.stringify(bhfPossibleYears)}</p>
                        <button onClick={addBd} value={bhfYears.at(-1) + 1}>{bhfYears.at(-1) + 1} neu anlegen</button>
                    </li>
                    <li>Liniendaten:
                        <p>bereits vorhanden: {JSON.stringify(ldYears)}</p>
                        <button onClick={addLd} value={ldYears.at(-1) + 1}>{ldYears.at(-1) + 1} neu anlegen</button>
                    </li>
                    <li>Verkehrsvertragsdaten:
                        <p>bereits vorhanden: {JSON.stringify(vvdYears)}</p>
                        <button onClick={addVvd} value={vvdYears.at(-1) + 1}>{vvdYears.at(-1) + 1} neu anlegen</button>
                    </li>
                </ul>
            </div>


        </div>
    )
}
